import { AnimateLayoutChanges, defaultAnimateLayoutChanges, useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import {
  PipelineCreateStageInterface,
  PipelineEditInterface,
} from 'modules/crm/types/pipeline-interface'
import React, { Dispatch, SetStateAction, useState } from 'react'
import ConfirmationModal from 'shared/components/confirmation-modal'
import { FieldErrorAndDescription } from 'shared/components/form/field-error-and-description'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { BinIcon, DragIcon } from '@systemeio/ui/icons'

const animateLayoutChanges: AnimateLayoutChanges = args =>
  defaultAnimateLayoutChanges({ ...args, wasDragging: true })

interface PropsStatusesItem {
  setTempState: Dispatch<SetStateAction<PipelineEditInterface>>
  stage: PipelineCreateStageInterface
  showBin: boolean
  withConfirmation?: boolean
  error?: string
}

export const StageItem = ({
  stage,
  setTempState,
  showBin,
  withConfirmation,
  error,
}: PropsStatusesItem) => {
  const { t } = useLocoTranslation()
  const [isOpenedConfirmation, setIsOpenedConfirmation] = useState<boolean>(false)

  const { attributes, isDragging, listeners, setNodeRef, transition, transform } = useSortable({
    id: stage.position,
    animateLayoutChanges,
  })

  const style = {
    transition,
    transform: CSS.Translate.toString(transform),
    opacity: isDragging ? 0.5 : undefined,
  }

  const handelChangeNameStage = (stages: PipelineCreateStageInterface, value: string) => {
    setTempState(prevState => ({
      ...prevState,
      stages: prevState.stages.map(item => {
        if (item.position === stages.position) {
          return {
            ...item,
            name: value,
          }
        }
        return item
      }),
    }))
  }

  const removeStage = () =>
    setTempState(prevState => ({
      ...prevState,
      stages: prevState.stages.filter(item => item.position !== stage.position),
    }))

  return (
    <div className={'mb-4 mr-2'}>
      <div
        className={`focus-within:border-brand-primary disabled:bg-background-tertiary/40 group/item flex rounded-lg border px-4 py-3 transition ${
          error ? 'border-danger' : 'border-text-secondary/30'
        }`}
        ref={setNodeRef}
        style={style}
        {...attributes}
        {...listeners}
      >
        <DragIcon className={'mr-4 cursor-grab'} />
        <input
          type={'text'}
          spellCheck={false}
          placeholder={t('dashboard.crm_pipeline.modal.placeholder_name_pipeline')}
          onChange={e => handelChangeNameStage(stage, e.target.value)}
          value={stage.name}
          className={
            'text-brand-primary placeholder:text-text-tertiary/70 basis-full text-[17px] font-medium focus:outline-hidden'
          }
        />
        {showBin && (
          <button onClick={() => {}} className={'group-hover/item:visible group invisible'}>
            <BinIcon
              onClick={() => (withConfirmation ? setIsOpenedConfirmation(true) : removeStage())}
              className={
                'group-hover:fill-danger group-focus-visible:fill-danger main-transition-colors h-[20px] w-[20px] '
              }
            />
          </button>
        )}
      </div>
      <FieldErrorAndDescription error={error} />
      <ConfirmationModal
        opened={isOpenedConfirmation}
        onClose={() => setIsOpenedConfirmation(false)}
        onConfirm={() => removeStage()}
        confirmationText={t('dashboard.crm_pipeline.edit_modal.confirmation_text')}
      />
    </div>
  )
}
